export default function getDefaultPage() {
  return '/'
}
